import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dance-city-dance',
  templateUrl: './dance-city-dance.component.html',
  styleUrls: ['./dance-city-dance.component.scss']
})
export class DanceCityDanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
